import React from "react";
import { getStyleJSON } from "Utils/Common";
import userservice from "service/UserDataService";
import { DialogButton } from "Common/DialogButton";

export const AddCreditsRows = () => {
  const [user, setUser] = React.useState("");
  const [amount, setAmount] = React.useState("");

  return (
    <>
      <tr>
        <td
          colSpan="2"
          style={getStyleJSON(
            "padding-left: 0px; padding-right: 0px; width: 300px;"
          )}
        >
          Add Credits:
        </td>
      </tr>
      <tr ng-init="addcreditsconfig={}">
        <td
          style={getStyleJSON(
            "padding-left: 0px; padding-right: 0px; width: 100px;"
          )}
        >
          <input
            placeholder="User"
            style={{ width: "150px" }}
            ng-model="addcreditsconfig.user"
            value={user}
            onChange={(e) => {
              setUser(e.target.value);
            }} />
        </td>
        <td
          style={getStyleJSON(
            "padding-left: 0px; padding-right: 0px; width: 100px;"
          )}
        >
          <input
            placeholder="Credits"
            style={{ width: "150px" }}
            ng-model="addcreditsconfig.amount"
            value={amount}
            onChange={(e) => {
              setAmount(e.target.value);
            }} />
        </td>
        <td
          style={getStyleJSON(
            "padding-left: 0px; padding-right: 0px; text-align: center; font-size: 15px"
          )}
          align="center"
        >
          <DialogButton
            label="Add"
            onClick={() => {
              userservice.addCredits({ amount, user });
            }} />
        </td>
      </tr>
    </>
  );
};
